export default "__VITE_ASSET__bVRepJOq__"